<script setup lang="ts">
import { onMounted } from 'vue'
import { usePublicStore } from './stores/public-store'
const publicStore = usePublicStore()
onMounted(() => {
    if (!publicStore.therapists.length) {
        publicStore.getAllTherapists()
    }
    if (!publicStore.teachers.length) {
        publicStore.getAllTeachers()
    }
})
</script>
<template>
    <RouterView />
</template>

<style lang="scss">
@import 'scss/main.scss';

#app {
    font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body {
    margin: 0;
    min-width: 20rem;
}
</style>
